export { useResolvedWindow } from "./useResolvedWindow";
